import type * as React from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface InternalMetricCardProps {
  title: string;
  value: string;
  hint: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export function InternalMetricCard({
  title,
  value,
  hint,
  icon: Icon,
}: InternalMetricCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {Icon ? <Icon className="text-muted-foreground h-4 w-4" /> : null}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-semibold tracking-tight">{value}</div>
        <p className="text-muted-foreground text-xs">{hint}</p>
      </CardContent>
    </Card>
  );
}
